/* ============================================================================
   LAH — TRAVA DO ELASTICO E DO TOQUE FANTASMA
   Tema: Testes de implementacao (5.0)

   ============================================================================
   O GATILHO ESTAVA ERRADO — e por isso nada funcionava
   ============================================================================
   As versoes anteriores ligavam a trava quando o body tinha a classe
   hidden-scroll. Mas nao e assim que o configurador anuncia que esta aberto:
   ele poe product-lens-select-open no PROPRIO elemento .product-lens-select.

   Resultado: a trava nunca ligou. Nem o bloqueio do elastico, nem o do toque
   durante o arrasto. Os dois problemas continuaram porque o codigo que deveria
   resolve-los saia na primeira linha, sempre.

   Agora o estado e lido de onde ele realmente vive. A licao: confirmar o
   gancho no HTML antes de depender dele — supor o nome da classe custou tres
   rodadas de correcao que nao corrigiam nada.

   ============================================================================
   1. O ELASTICO
   ============================================================================
   Cada quadro de elastico expoe area que nao existe e obriga o navegador a
   repintar. Num container com varias camadas, esse trabalho se acumula e, em
   aparelho com pouca memoria, derruba a aba.

   ============================================================================
   2. O VERDE QUE APARECIA SEM CLIQUE
   ============================================================================
   Arrastando o dedo sobre as opcoes, elas ficavam verdes como se tivessem sido
   escolhidas. No celular nao existe "passar o mouse": o Safari aplica o estado
   de hover ao encostar, e ele GRUDA ate o proximo toque em outro lugar.

   Enquanto o dedo arrasta, marcamos o corpo com .lah-rolando e o CSS desliga
   os eventos de ponteiro nas opcoes. Um toque simples nao dispara arrasto,
   entao clicar continua funcionando — so o ARRASTO e neutralizado.
   ============================================================================ */

(function () {
    'use strict';

    if (!('ontouchstart' in window)) return;

    /* Como o configurador anuncia que esta aberto — confirmado no HTML de
       product-lens-select.liquid, nao suposto. */
    var SELETOR_ABERTO = '.product-lens-select.product-lens-select-open';
    var PAINEIS = '.lah-turbo-tela.is-open, .lah-prazo.is-open, .lah-cmp-painel.is-open';

    var CLASSE_ROLANDO = 'lah-rolando';

    var inicioY = 0;
    var arrastando = false;
    var soltar = null;

    function telaCheiaAberta() {
        return !!document.querySelector(SELETOR_ABERTO) ||
               !!document.querySelector(PAINEIS) ||
               document.body.classList.contains('hidden-scroll');
    }

    function containerRolavel(alvo) {
        var el = alvo;

        while (el && el !== document.body && el !== document.documentElement) {
            if (el.scrollHeight > el.clientHeight + 1) {
                var estilo = getComputedStyle(el).overflowY;
                if (estilo === 'auto' || estilo === 'scroll') return el;
            }
            el = el.parentNode;
        }

        return null;
    }

    document.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        inicioY = event.touches[0].clientY;
        arrastando = false;

        if (soltar) {
            clearTimeout(soltar);
            soltar = null;
        }
    }, { passive: true });

    /* NAO passivo: precisamos poder cancelar o gesto. Sai cedo sempre que nao
       ha tela cheia aberta, entao nao pesa na navegacao normal. */
    document.addEventListener('touchmove', function (event) {
        if (!telaCheiaAberta()) return;
        if (event.touches.length !== 1) return;

        var atualY = event.touches[0].clientY;

        /* Tres pixels de folga separam o arrasto do tremor natural do dedo
           durante um toque simples — sem isso, todo clique seria tratado como
           arrasto e nada responderia. */
        if (!arrastando && Math.abs(atualY - inicioY) > 3) {
            arrastando = true;
            document.body.classList.add(CLASSE_ROLANDO);
        }

        var alvo = event.target;
        if (!alvo || !alvo.closest) return;

        var container = containerRolavel(alvo);

        /* Nada rolavel sob o dedo: qualquer arrasto so produziria elastico. */
        if (!container) {
            event.preventDefault();
            return;
        }

        var indoParaBaixo = atualY > inicioY;
        var noTopo = container.scrollTop < 1;
        var noFim = container.scrollTop + container.clientHeight >= container.scrollHeight - 1;

        if ((noTopo && indoParaBaixo) || (noFim && !indoParaBaixo)) {
            event.preventDefault();
        }
    }, { passive: false });

    function terminar() {
        if (!arrastando) return;
        arrastando = false;

        /* Pequena espera antes de devolver o toque: o Safari ainda entrega o
           evento de clique logo depois do dedo levantar, e devolver na hora
           faria a opcao sob o dedo ser escolhida sem intencao. */
        soltar = setTimeout(function () {
            document.body.classList.remove(CLASSE_ROLANDO);
            soltar = null;
        }, 220);
    }

    document.addEventListener('touchend', terminar, { passive: true });
    document.addEventListener('touchcancel', terminar, { passive: true });
})();
